// GetSlotMachine returns all the options for the initialing the slot machine
export const OrderSuccessPageService_GetSlotMachineOptionsLazy = () =>
  import("./service.grpc").then(
    (m) => m.OrderSuccessPageService_GetSlotMachineOptions
  );
OrderSuccessPageService_GetSlotMachineOptionsLazy.method =
  "aysa_api.services.order_success_page.v1.OrderSuccessPageService/GetSlotMachineOptions" as const;

// SpinSlotMachine returns the voucher code result after the slot machine was spun
export const OrderSuccessPageService_SpinSlotMachineLazy = () =>
  import("./service.grpc").then(
    (m) => m.OrderSuccessPageService_SpinSlotMachine
  );
OrderSuccessPageService_SpinSlotMachineLazy.method =
  "aysa_api.services.order_success_page.v1.OrderSuccessPageService/SpinSlotMachine" as const;

// EmailVoucher sends the user an email having the voucher
// / Error Codes:
// / error - unable to send email
// / invalid argument - for invalid email address
export const OrderSuccessPageService_EmailVoucherLazy = () =>
  import("./service.grpc").then((m) => m.OrderSuccessPageService_EmailVoucher);
OrderSuccessPageService_EmailVoucherLazy.method =
  "aysa_api.services.order_success_page.v1.OrderSuccessPageService/EmailVoucher" as const;

// GetDeliveriesTimeDiff returns the delivery time differences between ADP and OSP which is used for tracking
// Web only
export const OrderSuccessPageService_GetDeliveriesTimeDiffLazy = () =>
  import("./service.grpc").then(
    (m) => m.OrderSuccessPageService_GetDeliveriesTimeDiff
  );
OrderSuccessPageService_GetDeliveriesTimeDiffLazy.method =
  "aysa_api.services.order_success_page.v1.OrderSuccessPageService/GetDeliveriesTimeDiff" as const;

// GetOrderSuccessPage returns the content of order success page
export const OrderSuccessPageService_GetOrderSuccessPageLazy = () =>
  import("./service.grpc").then(
    (m) => m.OrderSuccessPageService_GetOrderSuccessPage
  );
OrderSuccessPageService_GetOrderSuccessPageLazy.method =
  "aysa_api.services.order_success_page.v1.OrderSuccessPageService/GetOrderSuccessPage" as const;

// GetPageMetaData returns the meta data for the order success page page
export const OrderSuccessPageService_GetPageMetaDataLazy = () =>
  import("./service.grpc").then(
    (m) => m.OrderSuccessPageService_GetPageMetaData
  );
OrderSuccessPageService_GetPageMetaDataLazy.method =
  "aysa_api.services.order_success_page.v1.OrderSuccessPageService/GetPageMetaData" as const;
